import { DEFAULT_MIN_VALUE, DEFAULT_STEP, THUMB_DIAMETER } from "./constants";

/**
 * Функция для ограничения значения выходящего за допустимые пределы
 *
 * Пример: limitBoundaryValue(0, 100, 15) -> 15
 * Пример: limitBoundaryValue(0, 100, -15) -> 0
 * Пример: limitBoundaryValue(0, 100, 150) -> 100
 */
const getLimitedBoundaryValue = (min: number, max: number, value: number) => {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
};

/**
 * Функция для округления значения в рамках шага обновления
 *
 * Пример: getRoundedValueByStep(2, 5) -> 0
 * Пример: getRoundedValueByStep(3, 5) -> 5
 * Пример: getRoundedValueByStep(5, 5) -> 5
 */
const getRoundedValueByStep = (value: number, step: number) =>
  Math.round(value / step) * step;

/**
 * Функция для предоставления формулы расчета ширины линии заполнения в css,
 * в рамках выбранного значения на слайдере
 *
 * Пример: getFilledTrackWidth(0, 100, 1, 10) -> `calc(0.10 * (100% - 16px)`
 * Пример: getFilledTrackWidth(0, 100, 10, 14) -> `calc(0.10 * (100% - 16px)`
 * Пример: getFilledTrackWidth(0, 100, 10, 15) -> `calc(0.20 * (100% - 16px)`
 */
export const getFilledTrackWidth = (
  min: number,
  max: number,
  step: number,
  value: number
) => {
  if (min > max) {
    return DEFAULT_MIN_VALUE;
  }

  const range = max - min;
  const needRounding = step > DEFAULT_STEP;
  const boundariedValue = getLimitedBoundaryValue(min, max, value);
  const sliderValue = needRounding
    ? getRoundedValueByStep(boundariedValue, step)
    : boundariedValue;

  const ratio = (sliderValue - min) / range;

  return `calc(${ratio} * (100% - ${THUMB_DIAMETER}px)`;
};
